import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { FormulaireDTO } from 'src/app/parametrage/core/model/formulaire-dto';

@Injectable({
    providedIn: 'root'
  })
  export class SignatureService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    downloadFileAndRedirectUrl(subitemid) {
        return  this._restClientService.load<FormulaireDTO>('signature/download-file-and-redirect-url?subitemid='+subitemid);
    }
    
}      

    